import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Training.css';

const TrainingHome = () => {
  const trainingPrograms = [
    {
      id: 'ui-ux-design',
      title: 'UI/UX Design Training',
      icon: '🎨',
      color: '#8b5cf6',
      duration: '6 Weeks',
      level: 'Beginner to Advanced',
      description: 'Master user interface and experience design',
      features: ['Figma Mastery', 'Design Systems', 'User Research', 'Portfolio Building']
    },
    {
      id: 'full-stack-development',
      title: 'Full Stack Development',
      icon: '💻',
      color: '#10b981',
      duration: '12 Weeks',
      level: 'Intermediate',
      description: 'Complete web development training',
      features: ['React.js', 'Node.js', 'MongoDB', 'Deployment']
    },
    {
      id: 'frontend-development',
      title: 'Frontend Development',
      icon: '🖥️',
      color: '#3b82f6',
      duration: '8 Weeks',
      level: 'Beginner',
      description: 'Modern frontend development skills',
      features: ['HTML/CSS/JS', 'React', 'Responsive Design', 'Web Performance']
    },
    {
      id: 'backend-development',
      title: 'Backend Development',
      icon: '⚙️',
      color: '#f59e0b',
      duration: '10 Weeks',
      level: 'Intermediate',
      description: 'Server-side development training',
      features: ['Node.js', 'APIs', 'Databases', 'Security']
    },
    {
      id: 'digital-marketing',
      title: 'Digital Marketing',
      icon: '📈',
      color: '#ec4899',
      duration: '6 Weeks',
      level: 'Beginner',
      description: 'Comprehensive digital marketing training',
      features: ['SEO', 'Social Media', 'Content Marketing', 'Analytics']
    },
    {
      id: 'graphic-designing',
      title: 'Graphic Designing',
      icon: '✏️',
      color: '#6366f6',
      duration: '8 Weeks',
      level: 'Beginner',
      description: 'Professional graphic design training',
      features: ['Adobe Tools', 'Logo Design', 'Branding', 'Print Design']
    }
  ];

  return (
    <div className="training-home">
      {/* Hero Section */}
      <div className="training-hero">
        <div className="training-hero-content">
          <h1>Transform Your Career with Our Training Programs</h1>
          <p className="training-subtitle">
            Industry-leading courses designed by professionals for professionals
          </p>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-number">500+</div>
              <div className="stat-label">Students Trained</div>
            </div>
            <div className="stat">
              <div className="stat-number">95%</div>
              <div className="stat-label">Placement Rate</div>
            </div>
            <div className="stat">
              <div className="stat-number">50+</div>
              <div className="stat-label">Hiring Partners</div>
            </div>
          </div>
        </div>
      </div>

      {/* Programs Grid */}
      <div className="programs-container">
        <h2 className="section-title">Our Training Programs</h2>
        <p className="section-subtitle">
          Choose from our comprehensive range of courses
        </p>
        
        <div className="programs-grid">
          {trainingPrograms.map((program, index) => (
            <Link 
              to={`/training/${program.id}`}
              key={index}
              className="program-card-link"
            >
              <div className="program-card">
                <div 
                  className="program-header"
                  style={{ backgroundColor: `${program.color}15` }}
                >
                  <div className="program-icon" style={{ color: program.color }}>
                    {program.icon}
                  </div>
                  <div className="program-duration" style={{ backgroundColor: program.color }}>
                    {program.duration}
                  </div>
                </div>
                
                <div className="program-content">
                  <h3>{program.title}</h3>
                  <p className="program-description">{program.description}</p>
                  
                  <div className="program-level">
                    <span className="level-badge">{program.level}</span>
                  </div>
                  
                  <ul className="program-features">
                    {program.features.slice(0, 3).map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="program-footer">
                  <span className="enroll-button" style={{ color: program.color }}>
                    Learn More →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="benefits-section">
        <h2>Why Choose Our Training?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">👨‍🏫</div>
            <h4>Industry Experts</h4>
            <p>Learn from professionals with real-world experience</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">🎯</div>
            <h4>Project-Based Learning</h4>
            <p>Hands-on projects and real-world scenarios</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">🤝</div>
            <h4>Career Support</h4>
            <p>Resume building, interview prep, and job placement</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">🔄</div>
            <h4>Flexible Learning</h4>
            <p>Online, offline, and hybrid learning options</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingHome;